import script from "./CondolenceSummaryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CondolenceSummaryCard.vue?vue&type=script&setup=true&lang=js"

import "./CondolenceSummaryCard.vue?vue&type=style&index=0&id=474f0fd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-474f0fd7"]])

export default __exports__